import { render, staticRenderFns } from "./HelpCenterNav.vue?vue&type=template&id=b2fef054&scoped=true&"
import script from "./HelpCenterNav.vue?vue&type=script&lang=js&"
export * from "./HelpCenterNav.vue?vue&type=script&lang=js&"
import style0 from "./HelpCenterNav.vue?vue&type=style&index=0&id=b2fef054&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2fef054",
  null
  
)

export default component.exports